import { ReactElement, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Tabs, Tab, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import { ExpandMore } from '@mui/icons-material';
import { LAMBDA_WEB_HELLO_WORLD_FILES } from '@localstack/constants';

import { CodeSnippetViewer } from '@localstack/ui';

const TemplateDescription = styled(Typography)(({ theme }) => ({ marginBottom: theme.spacing(2) }));

export const TemplatePreview = (): ReactElement => {
  const [fileName, setFileName] = useState('index.js');
  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography>Hello World template</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <TemplateDescription variant="body2" color="text.secondary">
          A Node.js HTTP server with a home page and a JSON response at /hello-world.
        </TemplateDescription>
        <Tabs value={fileName} onChange={(_event, value: string) => setFileName(value)} aria-label="Template files">
          {Object.keys(LAMBDA_WEB_HELLO_WORLD_FILES).map((name) => (
            <Tab key={name} value={name} label={name} />
          ))}
        </Tabs>
        <CodeSnippetViewer
          data={LAMBDA_WEB_HELLO_WORLD_FILES[fileName] ?? ''}
          disableParsing
          expandableContainerHeight={360}
        />
      </AccordionDetails>
    </Accordion>
  );
};
